import React, { useEffect, Suspense } from "react";
import { useSearchParams } from "next/navigation";
import { VStack } from "@chakra-ui/react";
import Tabs from "@/components/tabs";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import { SERVICES_CONSTANTS } from "./constants";
import { tablist } from "./serviceTabsList";

const ID = "cloud-services-tab";

const useHandleScroll = () => {
  const searchParams = useSearchParams();
  const tab = searchParams.get("tab");
  useEffect(() => {
    if (tab) {
      scrollToElement(ID, 120);
    }
  }, [tab]);
};

const CloudCardsTabs = () => {
  useHandleScroll();
  const headingVariant = useHeadingVariant();
  return (
    <VStack id={ID} gap={4}>
      <Heading as="h2" variant={headingVariant}>
        {SERVICES_CONSTANTS.title}
      </Heading>
      <Text variant={"label1"} color={"text.100"} fontWeight={700}>
        {SERVICES_CONSTANTS.desc}
      </Text>
      <Suspense>
        <Tabs columns={{ base: 1, sm: 3 }} tabList={tablist} />
      </Suspense>
    </VStack>
  );
};

export default CloudCardsTabs;
